import { render, staticRenderFns } from "./ReviewNewInvestigator.vue?vue&type=template&id=6cba5d80"
import script from "./ReviewNewInvestigator.vue?vue&type=script&lang=js"
export * from "./ReviewNewInvestigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports